import clsx from "clsx";
import { makeStyles } from "tss-react/mui";

import { TableRow } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
    row: {
        "&:hover": {
            backgroundColor: theme.palette.emteria.background.listHover,
        },
    },
    selected: {
        backgroundColor: theme.palette.emteria.background.selectedRow,
        "&:hover": {
            backgroundColor: theme.palette.emteria.background.selectedRow,
        },
    },
    clickable: {
        cursor: "pointer",
    },
    notClickable: {
        cursor: "default",
    },
}));

type HoverRowProps = React.PropsWithChildren<{
    selected?: boolean;
    clickable?: boolean;
    className?: string;
    onClick?: (e: React.MouseEvent<HTMLTableRowElement>) => void;
}>;

export const HoverRow = (props: HoverRowProps) => {
    const { classes } = useStyles();
    const clickable = props.clickable !== false;

    return (
        <TableRow
            className={clsx(
                classes.row,
                props.selected && classes.selected,
                clickable ? classes.clickable : classes.notClickable,
                props.className,
            )}
            onClick={props.onClick}
        >
            {props.children}
        </TableRow>
    );
};
